import { jsx as t, Fragment as e } from "react/jsx-runtime";
import { DarkMode as m, LightMode as f } from "@chakra-ui/react";
const g = ({ children: r, mode: o }) => o === "dark" ? /* @__PURE__ */ t(m, { children: r }) : o === "light" ? /* @__PURE__ */ t(f, { children: r }) : /* @__PURE__ */ t(e, { children: r });
export {
  g as ThemeMode
};
//# sourceMappingURL=ThemeMode.es.js.map
